module.exports = __webpack_public_path__ + "newstatic/img/why-us-title.e05ba62.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/why-us-title.png
// module id = PZvV
// module chunks = 1